import {
  GetListResponse,
  Comment,
  CreateComment,
  UpdateComment,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _CommentService {
  public getComment(
    bookId: number | string,
    requestParams?: RequestParams,
    signal?: Signal
  ) {
    return HttpService.get<GetListResponse<Comment>>("/user/api/v2/comments", {
      queryParams: { ...requestParams, bookId },
      signal,
    });
  }

  public create(comment: CreateComment) {
    return HttpService.post("/user/api/v2/comments", {
      body: { ...comment },
    });
  }

  public likeComment(commentId: number) {
    return HttpService.post(`/user/api/v2/comments/${commentId}/like`);
  }

  public deleteComment(commentId: number) {
    return HttpService.delete(`/user/api/v2/comments/${commentId}`);
  }

  public editComment(comment: UpdateComment) {
    return HttpService.patch(`/user/api/v2/comments/${comment.commentId}`, {
      body: { content: comment.content },
    });
  }
}

const CommentService = new _CommentService();

export default CommentService;
